import { render, staticRenderFns } from "./teccompare.vue?vue&type=template&id=049f002a&scoped=true"
import script from "./teccompare.vue?vue&type=script&lang=js"
export * from "./teccompare.vue?vue&type=script&lang=js"
import style0 from "./teccompare.vue?vue&type=style&index=0&id=049f002a&prod&scoped=scoped&lang=css"
import style1 from "./teccompare.vue?vue&type=style&index=1&id=049f002a&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049f002a",
  null
  
)

export default component.exports